import { render, staticRenderFns } from "./AdminUI.html?vue&type=template&id=73b5d31a&scoped=true&external"
import script from "./AdminUI.js?vue&type=script&lang=js&external"
export * from "./AdminUI.js?vue&type=script&lang=js&external"
import style0 from "./AdminUI.scss?vue&type=style&index=0&id=73b5d31a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b5d31a",
  null
  
)

export default component.exports